/* @flow */
// typecheck: ignore file
import API from 'lib/RemindAPI';
import { call, fork, put } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import * as actions from 'reducers/roleBasedMessagingSearch';
import PotentialChatMembers from 'collections/PotentialChatMembers';

import type { loadPotentialChatMembersAction } from 'reducers/roleBasedMessagingSearch';

export function search(query: string): Promise<PotentialChatMembers> {
  return API.request('/chats/members/search', 'GET', { q: query }).then(members => {
    return PotentialChatMembers.fromJSON(members);
  });
}

export function* watchLoadPotentialChatMembers(): Generator<?any, ?any, ?any> {
  // $FlowFixMe ¯\_(ツ)_/¯
  yield* takeLatest('rbms/LOAD_POTENTIAL_CHAT_MEMBERS_REQUEST', loadPotentialChatMembers);
}

export function* loadPotentialChatMembers(action: loadPotentialChatMembersAction): Generator<?any, ?any, ?any> {
  try {
    const members: ?PotentialChatMembers = yield call(
      search,
      action.query,
    );

    if (members) {
      yield put(actions.loadPotentialChatMembersSuccess(
        members,
      ));
    }
  } catch (e) {
    console.warn(e);
  }
}

export default function* root(): Generator<?any, ?any, ?any> {
  yield [
    fork(watchLoadPotentialChatMembers),
  ];
}



// WEBPACK FOOTER //
// ./src/sagas/roleBasedMessagingSearch.js